import { useEffect } from 'react';

import { UploadData } from '../../../../components/data-importer/UploadData';
import { useCreateClients } from '../../../../hooks/client/useCreateClients';
import { useRetrieveActiveProject } from '../../../../hooks/project/useRetrieveActiveProject';
import { ClientMapper } from '../../../../mappers/client/ClientMapper';
import { CreateClientsList } from './fields/CreateClientsList';

interface UploadClientsDataProps {
  createClientsList: CreateClientsList;
  onComplete: () => void;
}

export const UploadClientsData = ({ createClientsList, onComplete }: UploadClientsDataProps) => {
  const { data: activeProject } = useRetrieveActiveProject();
  const { run: createClients, isLoading, error, success } = useCreateClients();

  useEffect(() => {
    if (activeProject?.custom_fields) {
      createClients({
        clients: createClientsList.getClients().map((stop) => {
          return ClientMapper.toDomain(stop, activeProject.custom_fields!.client);
        }),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (success) {
      onComplete();
    }
  }, [onComplete, success]);

  return <UploadData loading={isLoading} error={error} />;
};
